import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

interface DeleteViewColumnArguments {
  params: OpalApiRequestParams<'DeleteViewColumnV3'>
}

export async function deleteViewColumn({
  params,
}: DeleteViewColumnArguments): Promise<null> {
  const url = new URL(
    `/loupe/v3/view_columns/${params.path.view_column_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
